<template>
  <div class="bridge">
    <div class="bridge-up">
      <div class="bridge-tab" :class="{'active left-active': bridgeActive == 1}" @click="selectElement(1)">
        <div class="text">
          Native to ERC20
        </div>
      </div>
      <div class="bridge-tab" :class="{'active right-active': bridgeActive == 2}" @click="selectElement(2)">
        <div class="text">
          ERC20 to Native
        </div>
      </div>
    </div>

    <div class="bridge-down">
      <template v-if="bridgeActive == 1">
        <template v-if="polkadotjsConnectStatus == 0">
          <div class="polkadotjs" @click="$emit('connectPolkadotjs')">
            <div class="icon">
              <img src="../assets/polkadotjs.png" />
            </div>
            <div class="text">
              Connect to Polkadotjs extension
            </div>
          </div>
        </template>

        <template v-if="polkadotjsConnectStatus == 1">

          <div class="swap-content">
            <div class="input-desc">
              <div class="input-main-desc">
                From
              </div>
              <div class="input-balance-desc">
                <template v-if="selectedToken == 'fis'">
                  FIS balance: {{ fisBalance }}
                </template>
                <template v-if="selectedToken == 'rfis'">
                  rFIS balance: {{ rTokenBalance }}
                </template>
                <template v-if="selectedToken == 'rksm'">
                  rKSM balance: {{ rTokenBalance }}
                </template>
              </div>
            </div>

            <div class="inputs-amount">
              <input type="text" placeholder="0.0" v-model.trim="tokenAmount" @keyup="checkAmountInput" />
              <div class="icon">
                <img src="../assets/stafi.png" />
              </div>
              <div class="token-desc">
                <template v-if="selectedToken == 'fis'">
                  FIS
                </template>
                <template v-if="selectedToken == 'rfis'">
                  rFIS
                </template>
                 <template v-if="selectedToken == 'rksm'">
                  rKSM
                </template>
              </div>

              <select id='select_1' name='select_1' @change="nativeTokenChange">
                <template 
                  v-for="(item, index) in tokenItems" >
                  <option v-if="item.value == selectedToken" :key="'native-select-' + index" :value="item.value" selected="selected">{{ item.name }}</option>
                  <option v-else :key="'native-select-' + index" :value="item.value">{{ item.name }}</option>
                </template>
              </select>
            </div>

            <div class="down-icon">
              <img src="../assets/arrow-down.png" />
            </div>


            <div class="input-desc input-to">
              <div class="input-main-desc">
                To
              </div>
            </div>

            <div class="inputs-amount">
              <input type="text" class="input-amount" placeholder="0.0" v-model.trim="tokenAmount" readOnly="true" />
              <div class="icon">
                <img src="../assets/eth.png" />
              </div>
              <div class="token-desc">
                <template v-if="selectedToken == 'fis'">
                  FIS
                </template>
                <template v-if="selectedToken == 'rfis'">
                  rFIS
                </template>
                <template v-if="selectedToken == 'rksm'">
                  rKSM
                </template>
              </div>

            </div>


            <div class="inputs-amount eth-address">
              <input type="text" class="input-eth-address" placeholder="To Ethereum Address" 
                v-model.trim="ethAddress"  @keyup="checkEthInput" />
            </div>
            <div v-if="ethAddressAvailable" class="eth-link">
              Click on this <span class="link" @click="clickSwapLink">link</span> to check your swap status.
            </div>

            <div class="estimate">
              Estimate Gas Fee: {{ estimateFee }} FIS
            </div>

            <div class="swap-btn" :class="{'btn-active': swapActiveStatus == 1}" @click="swap">
              Swap
            </div>

          </div>
        </template>
      </template>

      <template v-if="bridgeActive == 2">
        <template v-if="metamaskConnectStatus == 0">
          <div class="metamask" @click="connectMetamask">
            <div class="icon">
              <img src="../assets/metamask.png" />
            </div>
            <div class="text">
              {{$t("home.connect-metamask")}}
            </div>
          </div>
        </template>

        <template v-if="metamaskConnectStatus == 1">

          <div class="swap-content">
            <div class="input-desc">
              <div class="input-main-desc">
                From
              </div>
              <div class="input-balance-desc">
                <template v-if="erc20SelectedToken == 'fis'">
                  ERC20 FIS balance: {{ erc20FisBalanceShow }}
                </template>
                <template v-if="erc20SelectedToken == 'rfis'">
                  ERC20 rFIS balance: {{ erc20RFisBalanceShow }}
                </template>
                <template v-if="erc20SelectedToken == 'rksm'">
                  ERC20 rKSM balance: {{ erc20RKSMBalanceShow }}
                </template>
              </div>
            </div>

            <div class="inputs-amount">
              <input type="text" placeholder="0.0" v-model.trim="tokenAmount" @keyup="checkAmountInput" />
              <div class="icon">
                <img src="../assets/eth.png" />
              </div>
              <div class="token-desc">
                <template v-if="erc20SelectedToken == 'fis'">
                  FIS
                </template>
                <template v-if="erc20SelectedToken == 'rfis'">
                  rFIS
                </template>
                <template v-if="erc20SelectedToken == 'rksm'">
                  rKSM
                </template>
              </div>

              <select id='select_2' name='select_2' @change="erc20TokenChange">
                <template 
                  v-for="(item, index) in tokenItems" >
                  <option v-if="item.value == erc20SelectedToken" :key="'erc20-select-' + index" :value="item.value" selected="selected">{{ item.name }}</option>
                  <option v-else :key="'erc20-select-' + index" :value="item.value">{{ item.name }}</option>
                </template>
              </select>
            </div>

            <div class="down-icon">
              <img src="../assets/arrow-down.png" />
            </div>


            <div class="input-desc input-to">
              <div class="input-main-desc">
                To
              </div>
            </div>

            <div class="inputs-amount">
              <input type="text" class="input-amount" placeholder="0.0" v-model.trim="tokenAmount" 
                readOnly="true"  />
              <div class="icon">
                <img src="../assets/stafi.png" />
              </div>
              <div class="token-desc">
                <template v-if="erc20SelectedToken == 'fis'">
                  FIS
                </template>
                <template v-if="erc20SelectedToken == 'rfis'">
                  rFIS
                </template>
                <template v-if="erc20SelectedToken == 'rksm'">
                  rKSM
                </template>
              </div>

            </div>


            <div class="inputs-amount eth-address">
              <input type="text" class="input-eth-address" placeholder="To StaFi Address" 
                v-model.trim="stafiAddress"  @keyup="checkStafiInput" />
            </div>
            <div v-if="stafiAddressAvailable" class="eth-link">
              Click on this <span class="link" @click="clickSwapToNativeLink">link</span> to check your swap status.
            </div>

            <div class="estimate">
              Estimate Gas Fee: {{ estimateEthFee }} ETH
            </div>

            <div class="swap-btn" :class="{'btn-active': erc20SwapActiveStatus == 1}" @click="erc20Swap">
              Swap
            </div>

          </div>
        </template>
      </template>

    </div>

    <DialogBtn
      v-if="dialogVisible1"
      :dialog-data="dialogData1"
      @sure="confirmSwapToERC20"
    />

    <DialogBtn
      v-if="dialogVisible2"
      :dialog-data="dialogData2"
      @sure="confirmSwapToNative"
    />
    
  </div>
</template>

<script>
import { setTimeout } from 'timers';
import rpc from '../util/rpc.js';
import { Toast } from 'mint-ui';
import { Indicator } from 'mint-ui';
import toolUtil from '../util/toolUtil.js';
import NumberUtil from '../util/numberUtil.js';
import Web3Util from '../util/web3Util.js';
import Api from '../util/SubstrateApi.js';
import LocalStorage from '../util/localStorage.js';
import { keccakAsHex } from '@polkadot/util-crypto';
import {
  web3Enable,
  web3FromSource,
} from '@polkadot/extension-dapp';
import keyring from '../keyring/Keyring';
import { RSymbol } from '../keyring/defaults';
import { u8aToHex } from '@polkadot/util';
import DialogBtn from '../components/dialogbtn';

const STAFI_CHAIN_ID = 1;
const ETH_CHAIN_ID = 2;

export default {
  name: 'rbridge',
  components: {
    DialogBtn
  },
  data() {
    return {
      bridgeActive: 1,
      polkadotjsConnectStatus: 0,
      metamaskConnectStatus: 0,
      currentFisAddress: '',
      currentEthAddress: '',
      selectedToken: 'fis',
      erc20SelectedToken: 'fis',
      fisBalance: '--',
      rTokenBalance: '--',
      erc20FisBalanceShow: '--',
      erc20FisBalance: '--',
      erc20RFisBalance: '--',
      erc20RFisBalanceShow: '--',
      erc20RKSMBalance: '--',
      erc20RKSMBalanceShow: '--',
      tokenItems: [
        {
          name: 'FIS',
          value: 'fis'
        },
        {
          name: toolUtil.getRSymbolNameByRSymbol(RSymbol.RFIS),
          value: 'rfis'
        },
        {
          name: toolUtil.getRSymbolNameByRSymbol(RSymbol.RKSM),
          value: 'rksm'
        }
      ],
      tokenAmount: '',
      ethAddress: '',
      ethAddressAvailable: false,
      stafiAddressAvailable: false,
      stafiAddress: '',
      estimateFee: '--',
      estimateEthFee: '0.000020',
      swapActiveStatus: 0,
      erc20SwapActiveStatus: 0,
      clickBtn: false,
      dialogVisible1: false,
      dialogData1: {},
      dialogVisible2: false,
      dialogData2: {},
    }
  },

  mounted() {
    // MetaMask Listener
    if (typeof window.ethereum !== 'undefined' && ethereum.isMetaMask) {
      ethereum.autoRefreshOnNetworkChange = false;
      ethereum.on('accountsChanged', (accounts) => {
        this.currentEthAddress = accounts[0];
        this.$emit('refreshEthBalance');
        if (this.erc20SelectedToken == 'fis') {
          this.handleErc20FisAmount();
        } else if (this.erc20SelectedToken == 'rfis') {
          this.handleErc20RFisAmount();
        } else if (this.erc20SelectedToken == 'rksm') {
          this.handleErc20RKSMAmount();
        }
      })
    }
  },

  methods: {
    selectElement(bridgeActive) {
      this.bridgeActive = bridgeActive;
      this.tokenAmount = '';
      this.init();
    },
    confirmSwapToERC20() {
      this.dialogVisible1 = false;

      setTimeout(() => {
        this.$emit('refreshFisBalance');
        this.handleNativeTokenAmount();
        this.tokenAmount = '';
        this.ethAddress = '';
        this.ethAddressAvailable = false;
        this.swapActiveStatus = 0;
      }, 500);

    },
    confirmSwapToNative() {
      this.dialogVisible2 = false;

      setTimeout(() => {
        this.$emit('refreshEthBalance');
        this.handleErc20TokenAmount();
        this.tokenAmount = '';
        this.stafiAddress = '';
        this.stafiAddressAvailable = false;
        this.erc20SwapActiveStatus = 0;
      }, 500);
    },
    nativeTokenChange() {
      let token = event.target.value;
      if (token == this.selectedToken) {
        return;
      }
      this.selectedToken = token;
      this.handleNativeTokenAmount();
    },
    handleNativeTokenAmount() {
      if (this.selectedToken == 'fis') {
        this.handleFisAmount();
      } else if (this.selectedToken == 'rfis') {
        this.handleRTokenAmount(RSymbol.RFIS);
      } else if (this.selectedToken == 'rksm') {
        this.handleRTokenAmount(RSymbol.RKSM);
      }
    },
    erc20TokenChange() {
      let token = event.target.value;
      if (token == this.erc20SelectedToken) {
        return;
      }
      this.erc20SelectedToken = token;
      this.handleErc20TokenAmount();
    },
    handleErc20TokenAmount() {
      if (this.erc20SelectedToken == 'fis') {
        this.handleErc20FisAmount();
      } else if (this.erc20SelectedToken == 'rfis') {
        this.handleErc20RFisAmount();
      } else if (this.erc20SelectedToken == 'rksm') {
        this.handleErc20RKSMAmount();
      }
    },
    checkInput() {
      if (this.tokenAmount > 0 && this.ethAddressAvailable) {
        this.swapActiveStatus = 1;
      }
    },
    checkErc20Input() {
      if (this.tokenAmount > 0 && this.stafiAddressAvailable) {
        this.erc20SwapActiveStatus = 1;
      }
    },
    checkAmountInput() {
      if (this.tokenAmount && !isNaN(this.tokenAmount) && this.tokenAmount >= 0) {
        let totalToken = 0;
        if (this.bridgeActive == 1) {
          if (this.selectedToken == 'rfis' || this.selectedToken == 'rksm') {
            totalToken = this.rTokenBalance;
          } else {
            totalToken = this.fisBalance;
          }
        } else if (this.bridgeActive == 2) {
          if (this.erc20SelectedToken == 'rfis') {
            totalToken = this.erc20RFisBalance;
          } else if (this.erc20SelectedToken == 'rksm') {
            totalToken = this.erc20RKSMBalance;
          } else {
            totalToken = this.erc20FisBalance;
          }
        }
        
        if (Number(this.tokenAmount) > Number(totalToken)) {
          Toast({ 
            message: 'The input amount exceeds your balance', 
            duration: 3000 
          });
          this.tokenAmount = '';
          this.swapActiveStatus = 0;
          this.erc20SwapActiveStatus = 0;
          return;
        }
        this.tokenAmount = this.tokenAmount.replace(/^(\-)*(\d+)\.(\d\d\d\d\d\d).*$/,'$1$2.$3');
        if (this.bridgeActive == 1) {
          this.checkInput();
        } else {
          this.checkErc20Input();
        }
      } else {
        if (this.tokenAmount != '') {
          Toast({ 
            message: 'The input amount is invalid', 
            duration: 3000 
          });
        }
        this.tokenAmount = '';
        this.swapActiveStatus = 0;
        this.erc20SwapActiveStatus = 0;
      }
    },
    checkEthInput() {
      if (this.checkEthAddress(this.ethAddress)) {
        this.ethAddressAvailable = true;
        this.checkInput();
      } else {
        this.swapActiveStatus = 0;
      }
    },
    checkStafiInput() {
      const keyringInstance = keyring.init('fis');
      if (keyringInstance.checkAddress(this.stafiAddress)) {
        this.stafiAddressAvailable = true;
        this.checkErc20Input();
      } else {
        this.erc20SwapActiveStatus = 0;
      }
    },
    checkAddressChecksum(address) {
      // Check each case
      address = address.replace(/^0x/i, '');
      var addressHash = keccakAsHex(address.toLowerCase()).substr(2);

      for (var i = 0; i < 40; i++) {
          // the nth letter should be uppercase if the nth digit of casemap is 1
        if ((parseInt(addressHash[i], 16) > 7 && address[i].toUpperCase() !== address[i])
          || (parseInt(addressHash[i], 16) <= 7 && address[i].toLowerCase() !== address[i])) {
              return false;
          }
      }
      return true;
    },
    checkEthAddress(address) {
      // check if it has the basic requirements of an address
      if (!/^(0x)?[0-9a-f]{40}$/i.test(address)) {
        return false;
        // If it's ALL lowercase or ALL upppercase
      } else if (/^(0x|0X)?[0-9a-f]{40}$/.test(address) || /^(0x|0X)?[0-9A-F]{40}$/.test(address)) {
        return true;
        // Otherwise check each case
      } else {
        return this.checkAddressChecksum(address);
      }
    },
    swap() {
      if (this.swapActiveStatus == 0) {
        return;
      }
      if (this.clickBtn) {
        return;
      }

      if (this.fisBalance <= this.estimateFee) {
        Toast({ 
          message: 'No enough FIS to pay for the fee', 
          duration: 3000 
        });
        return;
      }

      // this.clickBtn = true;

      const amount = NumberUtil.fisAmountToChain(this.tokenAmount.toString());

      Indicator.open('Loading...');

      web3Enable(Api.getWeb3EnalbeName());
      web3FromSource(Api.getPolkadotJsSource()).then(injector => {

        Api.createStafiApi().then(api => {

          let currentAccount = LocalStorage.getCurrentFisAccount();

          let tx = '';
          let symbolName = '';

          if (this.selectedToken == 'fis') {
            symbolName = 'FIS';
            tx = api.tx.bridgeSwap
              .transferNative(amount.toString(), this.ethAddress, ETH_CHAIN_ID);
          } else if (this.selectedToken == 'rfis') {
            symbolName = toolUtil.getRSymbolNameByRSymbol(RSymbol.RFIS);
            tx = api.tx.bridgeSwap
              .transferRtoken(RSymbol.RFIS, amount.toString(), this.ethAddress, ETH_CHAIN_ID);
          } else if (this.selectedToken == 'rksm') {
            symbolName = toolUtil.getRSymbolNameByRSymbol(RSymbol.RKSM);
            tx = api.tx.bridgeSwap
              .transferRtoken(RSymbol.RKSM, amount.toString(), this.ethAddress, ETH_CHAIN_ID);
          }
          if (!tx) {
            return;
          }
          
          tx.signAndSend(currentAccount, { signer: injector.signer }, (result) => {
            
            if (result.status.isInBlock) {
              Indicator.close();
              this.clickBtn = false;

              result.events
                .filter(({ event: { section } }) => section === 'system')
                .forEach(({ event: { data, method } }) => {
                  if (method === 'ExtrinsicFailed') {
                    const [dispatchError] = data
                    if (dispatchError.isModule) {
                      try {
                        const mod = dispatchError.asModule;
                        const error = data.registry.findMetaError(new Uint8Array([mod.index.toNumber(), mod.error.toNumber()]));
                        let message = 'Something is wrong, please make sure you have enough FIS balance';
                        if (this.selectedToken == 'rfis') {
                          message = 'Something is wrong, please make sure you have enough FIS and rFIS balance';
                        }
                        if (error.name == 'ServicePaused') {
                          message = 'Service is paused, please try again later!';
                        }
                        Toast({ 
                          message: message, 
                          duration: 3000 
                        });
                      } catch (error) {
                        Toast({ 
                          message: error.message, 
                          duration: 3000 
                        });
                      }
                    }
                  } else if (method === 'ExtrinsicSuccess') {

                    this.dialogData1 = {
                      icon: require('../assets/broadcast.png'),
                      lTitle: 'Tx Broadcasting',
                      content: 'Tx is broadcasting, please check your ' + symbolName + ' balance on your metamask later. It may take 2~10 minutes',
                      type: 2,
                      rightBtnText: 'Understood'
                    };
                    this.dialogVisible1 = true;

                  }
                });
            } else if (result.isError) {
              Indicator.close();
              this.clickBtn = false;

              Toast({ 
                message: result.toHuman(), 
                duration: 3000 
              });
            }

          }).catch((error) => {
            Indicator.close();
            this.clickBtn = false;
            Toast({ 
              message: error.message, 
              duration: 3000 
            });
          });

        })
        .catch((error) => {
          Indicator.close();
          this.clickBtn = false;
          Toast({ 
            message: error.message, 
            duration: 3000 
          });
        });
        
      });
    },
    handleFisAmount() {
      Api.createStafiApi().then(api => {
        api.query.system.account(this.currentFisAddress).then(result => {
          if (result) {
            let fisBalance = NumberUtil.fisAmountToHuman(result.data.free);
            this.fisBalance = NumberUtil.handleFisAmountToFixed(fisBalance);
          }
        }).catch((error) => {});
      })
      .catch((error) => {});
    },

    handleRTokenAmount(rSymbol) {
      this.rTokenBalance = '--';
      Api.createStafiApi().then(api => {
        api.query.rBalances.account(rSymbol, this.currentFisAddress).then(accountData => {
          let data = accountData.toJSON();
          if (data && data.free > 0) {
            let rTokenBalance = NumberUtil.fisAmountToHuman(data.free);
            this.rTokenBalance = NumberUtil.handleFisAmountToFixed(rTokenBalance);
          } else {
            this.rTokenBalance = '0.000000';
          }
        });
      })
      .catch((error) => {});
    },

    handleErc20FisAmount() {
      let web3 = Web3Util.getWeb3();

      let contract = new web3.eth.Contract(Web3Util.getFISTokenAbi(), Web3Util.getFISTokenAddress(), {
        from: this.currentEthAddress
      });

      contract.methods.balanceOf(this.currentEthAddress).call().then(result => {
        this.erc20FisBalance = web3.utils.fromWei(result, 'ether');
        this.erc20FisBalanceShow = NumberUtil.handleEthAmountToFixed(this.erc20FisBalance.toString());
      });
    },
    handleErc20RFisAmount() {
      let web3 = Web3Util.getWeb3();

      let contract = new web3.eth.Contract(Web3Util.getRFISTokenAbi(), Web3Util.getRFISTokenAddress(), {
        from: this.currentEthAddress
      });

      contract.methods.balanceOf(this.currentEthAddress).call().then(result => {
        this.erc20RFisBalance = web3.utils.fromWei(result, 'ether');
        this.erc20RFisBalanceShow = NumberUtil.handleEthAmountToFixed(this.erc20RFisBalance.toString());
      });
    },
    handleErc20RKSMAmount() {
      let web3 = Web3Util.getWeb3();

      let contract = new web3.eth.Contract(Web3Util.getRKSMTokenAbi(), Web3Util.getRKSMTokenAddress(), {
        from: this.currentEthAddress
      });

      contract.methods.balanceOf(this.currentEthAddress).call().then(result => {
        this.erc20RKSMBalance = web3.utils.fromWei(result, 'ether');
        this.erc20RKSMBalanceShow = NumberUtil.handleEthAmountToFixed(this.erc20RKSMBalance.toString());
      });
    },
    connectMetamask() {
      if (typeof window.ethereum !== 'undefined' && ethereum.isMetaMask) {
        //Will Start the metamask extension
        ethereum.request({ method: 'eth_requestAccounts' }).then(accounts => {
          this.initEth(accounts[0]);
        })
        .catch((error) => {
          if (error.code === 4001) {
            Toast({ 
              message: 'Please connect to MetaMask.', 
              duration: 3000 
            });
          } else {
            Toast({ 
              message: error.message, 
              duration: 3000 
            });
          }
        }); 
      } else {
        Toast({ 
          message: 'Please install MetaMask!', 
          duration: 3000 
        });
      }
      
    },
    erc20Swap() {
      if (this.erc20SwapActiveStatus == 0) {
        return;
      }
      if (this.clickBtn) {
        return;
      }

      // this.clickBtn = true;

      let web3 = Web3Util.getWeb3();

      let tokenContract = '';
      let symbolName = '';

      if (this.erc20SelectedToken == 'fis') {
        symbolName = 'FIS';
        tokenContract = new web3.eth.Contract(Web3Util.getFISTokenAbi(), Web3Util.getFISTokenAddress(), {
          from: this.currentEthAddress
        });
      } else if (this.erc20SelectedToken == 'rfis') {
        symbolName = toolUtil.getRSymbolNameByRSymbol(RSymbol.RFIS);
        tokenContract = new web3.eth.Contract(Web3Util.getRFISTokenAbi(), Web3Util.getRFISTokenAddress(), {
          from: this.currentEthAddress
        });
      } else if (this.erc20SelectedToken == 'rksm') {
        symbolName = toolUtil.getRSymbolNameByRSymbol(RSymbol.RKSM);
        tokenContract = new web3.eth.Contract(Web3Util.getRKSMTokenAbi(), Web3Util.getRKSMTokenAddress(), {
          from: this.currentEthAddress
        });
      }
      if (!tokenContract) {
        return;
      }

      Indicator.open('Loading...');

      const amount = web3.utils.toWei(this.tokenAmount.toString());

      tokenContract.methods.approve(Web3Util.getBridgeErc20HandlerAddress(), amount).send()
      .then(approveResult => {
        if (approveResult && approveResult.status) {
          let bridgeContract = new web3.eth.Contract(Web3Util.getBridgeAbi(), Web3Util.getBridgeAddress(), {
            from: this.currentEthAddress
          });
          const sendAmount = web3.utils.toWei(this.estimateEthFee);

          let amountHex = web3.eth.abi.encodeParameter('uint256', amount);
          let lenHex = web3.eth.abi.encodeParameter('uint256', '32');
          const keyringInstance = keyring.init('fis');
          let rAddressHex = u8aToHex(keyringInstance.decodeAddress(this.stafiAddress));

          let data = amountHex + lenHex.slice(2) + rAddressHex.slice(2);
          
          bridgeContract.methods.deposit(STAFI_CHAIN_ID, Web3Util.getResourceId(this.erc20SelectedToken), data)
            .send({value: sendAmount}).then(result => {

            Indicator.close();
            this.clickStake = false;

            if (result && result.status) {

              this.dialogData2 = {
                icon: require('../assets/broadcast.png'),
                lTitle: 'Tx Broadcasting',
                content: 'Tx is broadcasting, please check your ' + symbolName + ' balance later. It may take 2~10 minutes',
                type: 2,
                rightBtnText: 'Understood'
              };
              this.dialogVisible2 = true;

            } else {
              Toast({ 
                message: 'Error! Please try again', 
                duration: 3000 
              });
            }
          })
          .catch((error) => {
            Indicator.close();
            this.clickStake = false;
            Toast({ 
              message: error.message, 
              duration: 3000 
            });
          });
        } else {
          Indicator.close();
          this.clickStake = false;

          Toast({ 
            message: 'Error! Please try again', 
            duration: 3000 
          });
        }
      })
      .catch((error) => {
        Indicator.close();
        this.clickStake = false;
        Toast({ 
          message: error.message, 
          duration: 3000 
        });
      });
      
    },
    clickSwapLink() {
      if (this.ethAddressAvailable && this.ethAddress) {
        let tokenAddress = '';
        if (this.selectedToken == 'fis') {
          tokenAddress = Web3Util.getFISTokenAddress();
        } else if (this.selectedToken == 'rfis') {
          tokenAddress = Web3Util.getRFISTokenAddress();
        } else if (this.selectedToken == 'rksm') {
          tokenAddress = Web3Util.getRKSMTokenAddress();
        }
        window.open('https://etherscan.io/token/' + tokenAddress + '?a=' + this.ethAddress);
      }
    },
    clickSwapToNativeLink() {
      if (this.stafiAddressAvailable && this.stafiAddress) {
        window.open('https://stafi.subscan.io/account/' + this.stafiAddress);
      }
    },
    initEth(ethAddress) {
      this.currentEthAddress = ethAddress;
      this.metamaskConnectStatus = 1;
      this.$emit('showAccount', 1);
      this.handleErc20TokenAmount();
    },
    init() {
      if (this.bridgeActive == 1) {
        if (LocalStorage.getCurrentFisAccount()) {
          this.polkadotjsConnectStatus = 1;
          this.currentFisAddress = LocalStorage.getCurrentFisAccount();
          this.handleNativeTokenAmount();
          Api.createStafiApi().then(api => {
            api.query.bridgeCommon.chainFees(ETH_CHAIN_ID).then(result => {
              if (result.toJSON()) {
                let estimateFee = NumberUtil.fisAmountToHuman(result.toJSON());
                this.estimateFee = NumberUtil.handleFisAmountToFixed(estimateFee);
              }
            }).catch((error) => {});
          })
          .catch((error) => {});
          this.$emit('showAccount', 2);
        }
      } else {
        if (ethereum.selectedAddress) {
          this.initEth(ethereum.selectedAddress);
        }
      }
    }
  },
  created() {
    this.estimateEthFee = Web3Util.getBridgeEstimateEthFee();
    if (typeof window.ethereum !== 'undefined' && ethereum.isMetaMask) {
      ethereum.autoRefreshOnNetworkChange = false;
    }
    this.init();
  }
}
</script>

<style lang="scss">
@import "../mixin.scss";

.bridge {
  background-color: #2B3239;
  width: 683px;
  height: 535px;
  padding-bottom: 50px;
  border-radius: 19px;

  .bridge-up {
    display: flex;
    
    .bridge-tab {
      cursor: pointer;
      text-align: center;
      font-size: 20px;
      padding: 20px 93px;
      width: 342px;
      position: relative;
    }

    .active {
      font-weight: bold;
      color: #00F3AB;
      background-color: #343C44;

      &::after {
        content: '';
        position: absolute;
        left: 126px;
        bottom: 0;
        height: 2px;
        width: 90px;
        background-color:  #00F3AB;
      }
    }

    .left-active {
      border-radius: 19px 0 0 0; 
    }

    .right-active {
      border-radius: 0 19px 0 0; 
    }

  }

  .bridge-down {
    margin-top: 50px;
    padding-left: 106px;
    padding-right: 96px;

    .polkadotjs {
      cursor: pointer;
      padding: 0px 24px;
      margin: auto;
      margin-top: 197px;
      display: flex;
      font-size: 18px;
      border: 1px solid #BFBFBF;
      width: 360px;
      border-radius: 3px;
      height: 51px;
      line-height: 51px;
      align-items: center;

      .icon {
        margin-right: 24px;
        width: 31px;
        height: 31px;
        img {
          width: 100%;
          height: 100%;
        }
      }

      .text {
        height: 22px;
        line-height: 22px;
      }
    }

    .swap-content {
      .input-desc {
        display: flex;

        .input-main-desc {
          font-size: 20px;
          flex: 1;
        }

        .input-balance-desc {
          font-size: 12px;
          color: #C4C4C4;
          padding-top: 9px;
        }
      }


      .inputs-amount {
        margin-top: 8px;
        height: 50px;
        border-radius: 3.65px;
        border: 1px solid #BFBFBF;
        padding-left: 15px;
        position: relative;
        display: flex;
        
        .icon {
          height: 20px;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: 80px;
          img {
            height: 100%;
          }
        }
        input {
          font-size: 22px;
          font-weight: bold;
          width: 385px;
          height: 48px;
          background-color: #2B3239;
          border: 0;
          color: #fff;

          &:focus {
            outline: none
          }
        }

        .token-desc {
          font-size: 20px;
          line-height: 52px;
          width: 50px;
        }

        select {
          border: none;
          background-color: #2B3239;
          color: #fff;
          font-weight: bold;
          font-size: 16px;
          outline: none;
          width: 18px;
        }

        .input-amount {
          font-size: 22px;
        }

        .input-eth-address {
          font-size: 16px;
        }
      }

      .eth-address {
        margin-top: 38px;
      }
      

      .down-icon {
        margin-top: 28px;
        height: 16px;
        text-align: center;
        img {
          height: 100%;
        }
      }

      .eth-link {
        margin-top: 8px;

        .link {
          cursor: pointer;
          color: #00F3AB;
          text-decoration: underline;
        }
      }

      .estimate {
        color: #C4C4C4;
        font-size: 12px;
        margin-top: 26px;
      }

      .swap-btn {
        cursor: pointer;
        margin-top: 18px;
        margin-left: 370px;
        width: 110px;
        height: 42px;
        line-height: 42px;
        font-size: 16px;
        color: #23292F;
        font-weight: bold;
        background-color: #00F3AB;
        opacity: 0.4;
        border-radius: 21px;
        text-align: center;
      }

      .btn-active {
        opacity: 1;
      }

    }

    .metamask {
      cursor: pointer;
      padding: 0px 24px;
      margin: auto;
      margin-top: 197px;
      display: flex;
      font-size: 18px;
      border: 1px solid #BFBFBF;
      width: 254px;
      border-radius: 3px;
      height: 51px;
      line-height: 51px;
      align-items: center;

      .icon {
        margin-right: 24px;
        width: 31px;
        height: 27px;
        img {
          width: 100%;
          height: 100%;
        }
      }

      .text {
        height: 22px;
        line-height: 22px;
      }
    }

  }

}
</style>
